"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function prop(key, obj) {
    if (obj === null)
        return undefined;
    if (obj === undefined)
        return function (obj) { return prop(key, obj); };
    return obj[key];
}
exports.default = prop;
//# sourceMappingURL=prop.js.map